import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/media/data/Documents/code/javascript/mdxp/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Arguments from 'gatsby-theme-docz/src/components/arguments.jsx';
import { Head } from '../src/extract';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "extract-components"
    }}>{`Extract Components`}</h1>
    <p>{`This page contains the documentation for all Extract Components that the `}<inlineCode parentName="p">{`@mdxp/components`}</inlineCode>{` package has to offer.`}</p>
    <hr></hr>
    <h2 {...{
      "id": "head"
    }}>{`Head`}</h2>
    <p>{`This component allows you to set metadata of your presentation inside of your MDX file.
It uses `}<inlineCode parentName="p">{`ReactDom.createPortal`}</inlineCode>{` in order to insert your tags at runtime.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`NOTE`}</strong><br parentName="p"></br>{`
`}{`You cannot use this component to overwrite existing tags like `}<inlineCode parentName="p">{`<title>`}</inlineCode>{` if they already exist on the page, as valid HTML only allows for one such tag in the HTML head.
If you need such behaviour, you can create your own extract component that uses eg. `}<a parentName="p" {...{
          "href": "https://github.com/nfl/react-helmet"
        }}>{`react-helmet`}</a>{`, but as it is quite a big dependency, we decided to create this "dumber" version instead.`}</p>
    </blockquote>
    <h3 {...{
      "id": "properties"
    }}>{`Properties`}</h3>
    <Arguments mdxType="Arguments">
      {{
        name: 'length',
        type: 'number',
        required: false,
        desc: 'Optional length that tells for how many slides this Head should be rendered.'
      }}
      {{
        name: 'children',
        type: 'node',
        required: false,
        desc: 'Valid elements that can be set in the HTML Head section.'
      }}
    </Arguments>
    <h3 {...{
      "id": "examples"
    }}>{`Examples`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-md"
      }}>{`<Head>
<title>My Awesome Presentation</tite>
<meta name="description" content="This is my awesome web based presentation" />
<meta name="author" content="0phoff" />
<meta name="keywords" content="Presentations, Slides, Deck, React, Web, HTML, CSS, JavaScript" />
</Head>

# SLIDE 1

Content

---
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      